import { createContext, useContext } from 'react'

import type { PolfEventQuery } from '@/__generated__/hooks'

export type CurrentEvent = NonNullable<PolfEventQuery['polfEvent']>

/**
 * Lives in its own module rather than in `EventDetailShell.tsx` **for
 * code-splitting reasons**, not tidiness.
 *
 * 17 event pages need `useCurrentEvent`. While it was exported from the shell's
 * module, every one of them statically imported the shell — so Vite could not
 * move `EventDetailShell` out of the entry chunk even though the router imports
 * it lazily ("dynamically imported ... but also statically imported by 37
 * files"), and the whole event tree stayed in the initial download. That cost
 * the floor phone and the projector a bundle they never render.
 *
 * Keep it that way: import the hook from here, never from `EventDetailShell`.
 */
export const EventContext = createContext<CurrentEvent | null>(null)

export const useCurrentEvent = (): CurrentEvent => {
  const ctx = useContext(EventContext)
  if (!ctx) {
    throw new Error('useCurrentEvent must be used inside <EventDetailShell />')
  }
  return ctx
}
